export default "__VITE_ASSET__DIwUn03___"